/* tslint:disable */
/* eslint-disable */
/**
 * Twometerguide API
 * API for the Twometerguide booking module
 *
 * The version of the OpenAPI document: 0.0.1
 * Contact: prot-two-meter-guide@7bits.it
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { TravelinePlacementKindDto } from './traveline-placement-kind-dto';
import {
    TravelinePlacementKindDtoFromJSON,
    TravelinePlacementKindDtoFromJSONTyped,
    TravelinePlacementKindDtoToJSON,
    TravelinePlacementKindDtoToJSONTyped,
} from './traveline-placement-kind-dto';

/**
 * Accommodation in a room
 * @export
 * @interface TravelinePlacementDto
 */
export interface TravelinePlacementDto {
    /**
     * String representation of accommodation
     * @type {string}
     * @memberof TravelinePlacementDto
     */
    code?: string | null;
    /**
     * 
     * @type {TravelinePlacementKindDto}
     * @memberof TravelinePlacementDto
     */
    kind: TravelinePlacementKindDto;
    /**
     * Number of accommodations
     * @type {number}
     * @memberof TravelinePlacementDto
     */
    count: number;
    /**
     * Minimum age in the age group<br />
     * Specified for child accommodation only
     * (Kind = Child | ExtraChild | ChildBandWithoutBed)
     * @type {number}
     * @memberof TravelinePlacementDto
     */
    minAge?: number | null;
    /**
     * Maximum age in the age group<br />
     * Specified for child accommodation only<br />
     * (Kind = Child | ExtraChild | ChildBandWithoutBed)
     * @type {number}
     * @memberof TravelinePlacementDto
     */
    maxAge?: number | null;
}



/**
 * Check if a given object implements the TravelinePlacementDto interface.
 */
export function instanceOfTravelinePlacementDto(value: object): value is TravelinePlacementDto {
    if (!('kind' in value) || value['kind'] === undefined) return false;
    if (!('count' in value) || value['count'] === undefined) return false;
    return true;
}

export function TravelinePlacementDtoFromJSON(json: any): TravelinePlacementDto {
    return TravelinePlacementDtoFromJSONTyped(json, false);
}

export function TravelinePlacementDtoFromJSONTyped(json: any, ignoreDiscriminator: boolean): TravelinePlacementDto {
    if (json == null) {
        return json;
    }
    return {
        
        'code': json['code'] == null ? undefined : json['code'],
        'kind': TravelinePlacementKindDtoFromJSON(json['kind']),
        'count': json['count'],
        'minAge': json['minAge'] == null ? undefined : json['minAge'],
        'maxAge': json['maxAge'] == null ? undefined : json['maxAge'],
    };
}

  export function TravelinePlacementDtoToJSON(json: any): TravelinePlacementDto {
      return TravelinePlacementDtoToJSONTyped(json, false);
  }

  export function TravelinePlacementDtoToJSONTyped(value?: TravelinePlacementDto | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'code': value['code'],
        'kind': TravelinePlacementKindDtoToJSON(value['kind']),
        'count': value['count'],
        'minAge': value['minAge'],
        'maxAge': value['maxAge'],
    };
}

